// extracted by mini-css-extract-plugin
export default {"ModalBody":"CropImg_ModalBody__vjEfX","ModalHeader":"CropImg_ModalHeader__NhySj","ModalFooter":"CropImg_ModalFooter__qAAIh","crossIcon":"CropImg_crossIcon__-AZZR"};